angular.module('impactx.list').controller('PersistentListFiltersCtrl', [
    '$scope',
    '$mdPanel',
    'dataGen',
    'TranslationService',
    'ToastService',
    PersistentListFiltersCtrl
]);

function PersistentListFiltersCtrl($scope, $mdPanel, dataGen, TranslationService, ToastService) {
    let self = this;

    $scope.trns = {
        delete: TranslationService.get('delete'),
        save: TranslationService.get('save'),
        defaultFilterSetting: TranslationService.get('defaultFilterSetting')
    };

    self.showMenu = function (ev) {
        $mdPanel.open({
            id: 'listfilterpanel',
            attachTo: angular.element(document.body),
            templateUrl: 'shared/list/templates/persistent-list-filters-panel.tmpl.html',
            focusOnOpen: false,
            zIndex: 100,
            propagateContainerEvents: true,
            clickOutsideToClose: true,
            controller: 'PersistentListFilterPanelCtrl',
            controllerAs: 'persistentListFilterPanelCtrl',
            locals: {
                listConfig: $scope.listConfig
            },
            panelClass: 'menu-panel-container',
            position: $mdPanel.newPanelPosition()
                .relativeTo(angular.element("#listfilterpanel"))
                .addPanelPosition(
                    $mdPanel.xPosition.ALIGN_START,
                    $mdPanel.yPosition.BELOW
                ),
            openFrom: ev,
            onCloseSuccess: function (a, b) {
                if(b === "saved" && $scope.refreshListFn) {
                    $scope.refreshListFn();
                }
            }
        });
    };

    self.setAsDefaultFilter = function () {
        var sqhId = impactX.isDefined($scope, 'listConfig.persistentListFilters.selected.filter.id');
        $scope.listConfig.persistentListFilters.selected.isDefault = !$scope.listConfig.persistentListFilters.selected.isDefault;

        if (sqhId) {
            dataGen.postAsForm({}, {
                sqhId: sqhId,
                asDefault: $scope.listConfig.persistentListFilters.selected.isDefault
            }, "/list/filter/setDefault").then(function (data) {
                angular.forEach($scope.listConfig.persistentListFilters.entries, function (entry) {
                    entry.isDefault = false;
                });
                $scope.listConfig.persistentListFilters.selected = data.data;
            })
        }
    };

    self.deletePersistentFilter = function () {
        var selected = impactX.isDefined($scope, 'listConfig.persistentListFilters.selected');
        if (selected) {
            dataGen.postAsForm({}, {sqhId: selected.filter.id}, "/list/filter/delete").then(function (data) {
                var index = $scope.listConfig.persistentListFilters.entries.indexOf(selected);
                $scope.listConfig.persistentListFilters.entries.splice(index, 1);

                var filterBlocks = $scope.listConfig.persistentListFilters.selected.filterBlocks;
                angular.forEach(filterBlocks, function (filterBlock) {
                    angular.forEach(filterBlock.filterValues, function (value) {
                        value.stringValue = undefined;
                    });
                });
                $scope.listConfig.persistentListFilters.selected = undefined;
                $scope.refreshListFn({filterBlocks: filterBlocks});

                if (data.data.value) {
                    ToastService.openStandardToast(data.data.label);
                }
            })
        }
    };

    self.deleteSelected = function () {
        if(impactX.isDefined($scope, 'listConfig.persistentListFilters.selected')) {
            var filterBlocks = $scope.listConfig.persistentListFilters.selected.filterBlocks;
            angular.forEach(filterBlocks, function (filterBlock) {
                angular.forEach(filterBlock.filterValues, function (value) {
                    value.stringValue = undefined;
                });
            });
            $scope.listConfig.persistentListFilters.selected = undefined;
            $scope.refreshListFn({filterBlocks: filterBlocks});
        }
    };
}